import { HttpRequestType } from "./HttpRequestType";
import { SetupHttpRequestUtil } from "../../../SetupHttpRequestUtil";
var ResponseType = HttpRequestType.ResponseType;
export default class HttpRequestOption {
    constructor() {
        this.responseType = ResponseType.Json;
        this.progressMessage = null;
        this.errorCallback = (response) => {
        };
        this.finishCallback = (response) => {
        };
        this.signalId = null; // 一意なシグナルIDを指定すると、多重リクエスト時に前のリクエストをキャンセルされる
        this.displayMessageType = HttpRequestType.DisplayMessageType.All;
        this.successMessageRequestCallback = null;
        // 外から呼び出せないようにする
    }
    static createForGet() {
        const option = new HttpRequestOption();
        option.displayMessageType = HttpRequestType.DisplayMessageType.ErrorOnly;
        return option;
    }
    static createForPost() {
        const option = new HttpRequestOption();
        option.progressMessage = SetupHttpRequestUtil.setting.defaultPostProgressMessage;
        return option;
    }
    static createForDelete() {
        const option = new HttpRequestOption();
        option.progressMessage = SetupHttpRequestUtil.setting.defaultDeleteProgressMessage;
        return option;
    }
    static createForPut() {
        return new Option();
    }
}
